module.exports = __webpack_public_path__ + "static/media/posto-shell.40180279.png";